module.exports = __webpack_public_path__ + "static/media/account.c87f8bb2.svg";